/**
 * Where the resource scheduler lives. Configuration rather than a constant, so
 * renaming that App Service is a repo variable and not a Fieldpath deploy — but
 * with a default, so a checkout that sets nothing still builds a working link.
 *
 * Its own module so a component can link there without importing `App`,
 * which imports every screen.
 */
/**
 * The Wrike archive (Jeremy, 2 Nov 2026): Wrike's history, read-only, its own
 * Static Web App and sign-in (`energy-renewal-partners/wrike-archive`).
 */
export const wrikeArchiveUrl = "https://erpwa.energyrenewalpartners.com/";

export const schedulerUrl =
  // `||`, not `??`: an unset workflow input arrives as "", which `??` would keep -- a link to
  // nowhere. Production passes nothing and lands here; dev passes its own scheduler.
  import.meta.env.VITE_SCHEDULER_URL || "https://erpsch.energyrenewalpartners.com";
